<template>
  <div class="com-order">
    <div class="top-order">
        <p class="or-header">感谢您订购我们的产品，您的订单编号:<a class="sub-color">10149892</a></p>
        <p class="or-content">订单详情 <span class="sub-tip">你可以拖拽该区域进行查看）</span></p>
        <ul class='ord-pro clearfix'>
            <li>
                <img src="../assets/image/plp.png">
            </li>
            <li>
                <img src="../assets/image/plp.png">
            </li>
             <li>
                <img src="../assets/image/plp.png">
            </li>
             <li>
                <img src="../assets/image/plp.png">
            </li>
             <li>
                <img src="../assets/image/plp.png">
            </li>
        </ul>
        <p class="sub-color total-count">总价格：2321</p>
    </div>
    <div class="comment-popup" v-show="computed">
        <div class="pop-bg">
          <h3 class="pop-header">恭喜获得返场券1张~</h3>
          <p class="pop-title">返场券将在10个工作日内发送到您的账户中</p>
          <button class="pop-btn" @click="handleHide">知道了</button>
          <div class="pop-bottom">
              <a class='sub-color fr'>什么是返场券</a>
              <a class='sub-color fl'>如何使用？</a>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
      return{
          computed:true
      }
  },
  methods:{
      handleHide(){
          this.computed=false;
      }
  }
}
</script>
<style scoped>
.top-order{
    width:90%;
    margin:0 auto;
}
.top-order .or-header{
    width:100%;
    font-size:12px;
    padding:14px 0 12px 0;
    color:#000;
    font-weight: 500;
    border-bottom:1px dashed #E2E2E2;

}
a.sub-color{
    text-decoration: underline;
}
span.sub-tip{
    color:#ADADAD;
    font-size: 10px;
}
.or-content{
    font-size:13px;
    font-weight: 500;
    padding:10px 0 8px 0;
}
.ord-pro{
    width: 100%;
    display: -webkit-box;
    overflow-x: scroll;
    -webkit-overflow-scrolling:touch;
    padding-bottom:16px;
    border-bottom:1px dashed #E2E2E2;
}
.ord-pro li{
    width:15%;
    height:60px;
    border:1px solid #eee;
}
.ord-pro li:not(:first-child){
    margin-left:4%;
}
.ord-pro li img{
    width:100%;
    height:60px;
}
.total-count{
    padding-top:10px;
    font-size: 12px;
}
.comment-popup {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.2);
}
.pop-bg {
    position: absolute;
    left: 10%;
    right: 10%;
    top: 32%;
    background-color: #ffffff;
    text-align: center;
}
.pop-bg .pop-header{
    padding-top:45px;
    font-size: 15px;
}
.pop-title {
    color: #939393;
    font-size: 11px;
    margin: 12px 0 30px 0;
    text-align: center;
}
.pop-btn {
    width: 80%;
    height: 40px;
    line-height: 40px;
    background-color: #0A83D6;
    color:#fff;
    border:none;
    font-size:18px;
    margin-bottom:12px;
}
.pop-bottom{
    width:80%;
    margin:0 auto;
    padding-bottom: 56px;
}
.pop-bottom a{
    color:#939393;
    font-size: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/ComputedOrder.vue